import React, { useEffect, useState } from 'react'
import { BGs, rawDataNumberPlates } from '../../constants/rowData.constants'
import Select from '../customSelect/select'
import { MdEdit } from 'react-icons/md'
import { FaList } from 'react-icons/fa6'
import { CLOUD_URL, defaultValues } from '../../constants/common.constants'
import axios from 'axios'
import { getImage, uploadImages, useCarromm } from '../../context/carrom'
import InputField from '../formComponents/inputField'
import { hexToGbr, updateFileStatus } from '../../utilities'
import { toast } from 'react-hot-toast'
import LoadingSpinner from '../spinner/loadingSpinner'
// const chunkSize = 100 * 1024;

function Form () {
  let timer
  const carrom = useCarromm()
  const fileDetails = carrom.holdFile
  const stopLoadingButtton =
    carrom?.holdFile[carrom?.holdFile?.length - 1]?.uploadStatus ===
      'processing_failed' ||
    carrom?.holdFile[carrom?.holdFile?.length - 1]?.uploadStatus === 'processed'
  const [showDropdown, setShowDropDown] = useState({
    bg_Id: true,
    number_plate: true
  })
  const [files, setFiles] = useState(carrom?.input || [])
  const [holdId, setHoldId] = useState(null)
  const [inProgressIndex, setInProgressIndex] = useState(null)
  // const [currentFileIndex, setCurrentFileIndex] = useState(null);
  const [lastUploadedFileIndex, setLastUploadedFileIndex] = useState(null)
  const [url, setUrl] = useState(null)
  const [skuId, setSkuId] = useState(null)
  // const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [formData, setFormData] = useState(defaultValues)
  const backgroundOptions = BGs.map(bg => {
    return {
      label: bg.name,
      value: bg.id
    }
  })
  console.log(carrom)
  const NumberPlateOptions = rawDataNumberPlates.map(numb => {
    return {
      label: numb.name,
      value: numb.id,
      thumbnail: numb?.thumbnail
    }
  })
  const handleInputChange = (e, fieldName, isSelect) => {
    const value =
      isSelect === 'select'
        ? e
        : e?.target?.type === 'checkbox'
        ? e?.target?.checked
        : e?.target?.value
    if (fieldName === 'bg_id') {
      setFormData(prevState => ({
        ...prevState,
        bg_id: isSelect === 'select' ? value?.value : value
      }))
    } else if (fieldName === 'number_plate') {
      setFormData(prevState => ({
        ...prevState,
        number_plate: isSelect === 'select' ? value?.thumbnail : value
      }))
    } else if (fieldName === 'interior_regeneration') {
      setFormData(prevState => ({
        ...prevState,
        interior_regeneration: value
      }))
    } else if (
      fieldName === 'TRANSPARENCY' ||
      fieldName === 'TINT_COLOR' ||
      fieldName === 'TONE_ON_TONE' ||
      fieldName === 'ADD_GLARE'
    ) {
      if (fieldName === 'TINT_COLOR') {
        const rgbValue = hexToGbr(value)
        setFormData(prevState => ({
          ...prevState,
          window_refinement: {
            ...prevState.window_refinement,
            [fieldName]: rgbValue
          }
        }))
      } else {
        setFormData(prevState => ({
          ...prevState,
          window_refinement: {
            ...prevState.window_refinement,
            [fieldName]: value
          }
        }))
      }
    }
  }
  function uploadFile (fileObject) {
    const formData = new FormData()
    if (fileObject?.length) {
      Array?.from(fileObject).forEach(image => {
        formData.append('upload', image)
      })
    } else {
      formData.append('upload', fileObject[0])
    }
    const headers = { 'Content-Type': 'multipart/form-data' }
    const url = `${CLOUD_URL}/upload`
    axios.post(url, formData, { headers }).then(response => {
      if (response?.data?.data?.length > 0) {
        let updatedHoldFile = [...fileDetails]
        Array?.from(response?.data?.data).forEach((links, i) => {
          updateFileStatus(i, 'Warten auf Url...', carrom)
          const file = files[i]
          file.finalFilename = links
          const varibles = {
            id: i,
            file: files[i],
            type: 'url',
            value: `${links}`,
            status: '',
            response: null,
            sku_id: null,
            input_url: null,
            output_url: null
          }
          updatedHoldFile = updatedHoldFile.map((item, index) => {
            if (index == i) {
              return {
                ...item,
                value: `${links}`,
                uploadStatus: 'Start uploading...',
                file: files[i]
              }
            } else {
              return item
            }
          })

          if (i === 0) {
            processImage(varibles)
          }
        })
        carrom.setHoldFile(updatedHoldFile)
      } else {
        toast('Something went wrong.')
      }
    })
  }
  useEffect(() => {
    if (stopLoadingButtton) {
      carrom?.setIsButtonDisabled(false)
    }
    // eslint-disable-next-line
  }, [stopLoadingButtton])
  useEffect(() => {
    setFiles(carrom?.input)
  }, [carrom?.input, carrom?.input?.length])
  // useEffect(() => {
  //     if (lastUploadedFileIndex === null) {
  //         return;
  //     }
  //     const isLastFile = lastUploadedFileIndex === files?.length - 1;
  //     const nextFileIndex = isLastFile ? null : currentFileIndex + 1;
  //     setCurrentFileIndex(nextFileIndex);
  //     // eslint-disable-next-line
  // }, [lastUploadedFileIndex]);
  // useEffect(() => {
  //     if (currentFileIndex !== null) {
  //         setCurrentChunkIndex(0);
  //     }
  // }, [currentFileIndex]);
  // useEffect(() => {
  //     if (currentChunkIndex !== null) {
  //         readAndUploadCurrentChunk();
  //     }
  //     // eslint-disable-next-line
  // }, [currentChunkIndex]);
  const processImage = input => {
    try {
      if (!input?.value) {
        return
      }
      setHoldId(parseInt(input?.id))
      const windowRefinement = {
        TRANSPARENCY: Number(
          formData?.window_refinement?.TRANSPARENCY ||
            defaultValues?.window_refinement?.TRANSPARENCY
        ),
        TINT_COLOR:
          formData?.window_refinement?.TINT_COLOR ||
          defaultValues?.window_refinement?.TINT_COLOR,
        TONE_ON_TONE: formData?.window_refinement?.TONE_ON_TONE
          ? 'True'
          : 'False',
        ADD_GLARE: formData?.window_refinement?.ADD_GLARE ? 'True' : 'False'
      }
      let formdata = new FormData()
      formdata.append('bg_id', formData?.bg_id)
      formdata.append('window_refinement', JSON.stringify(windowRefinement))
      formdata.append('interior_regeneration', formData?.interior_regeneration)
      formdata.append('number_plate', formData?.number_plate || '')
      formdata.append('extension', '')
      formdata.append('image_url', input?.value)
      uploadImages(formdata)
        .then(async res => {
          if (res.status === 'accepted') {
            //updateFileStatus(input?.id, "processing_failed", carrom);
            setSkuId(res?.sku_id)
            //setFinalStatus(res?.status);
            setTimeout(async () => {
              carrom?.setHoldFile(prevHoldFile => {
                return prevHoldFile.map(file => {
                  if (parseInt(file?.id) === parseInt(input?.id)) {
                    return {
                      ...file,
                      sku_id: res?.sku_id || null,
                      uploadStatus: res?.status
                    }
                  } else {
                    return file
                  }
                })
              })
              if (input?.id < fileDetails?.length && res?.sku_id) {
                timer = setInterval(() => {
                  processNextImage(input?.id, res?.sku_id, res?.status)
                }, 10000)
              }
            }, 2000)
          }
        })
        .catch(error => {
          setTimeout(async () => {
            carrom?.setHoldFile(prevHoldFile => {
              return prevHoldFile.map(file => {
                if (parseInt(file?.id) === parseInt(input?.id)) {
                  return {
                    ...file,
                    sku_id: 'error',
                    uploadStatus: 'processing_failed'
                  }
                } else {
                  return file
                }
              })
            })
            if (input?.id < fileDetails?.length) {
                timer = setInterval(() => {
                  processNextImage(input?.id, 'error', 'accepted')
                }, 10000)
              }
          }, 2000)
          toast(`Bild-Upload fehlgeschlagen: ${error}`)
          setSkuId('null')
        }, 2000)
    } catch (error) {
      toast(error.message)
    }
  }
  useEffect(() => {
    if (inProgressIndex < fileDetails?.length) {
      const currentFile = fileDetails.find(
        item => parseInt(item?.id) === parseInt(inProgressIndex)
      )
      if (currentFile?.sku_id) {
        // eslint-disable-next-line
        timer = setInterval(() => {
          processNextImage(
            currentFile?.id,
            currentFile?.sku_id,
            currentFile?.status
          )
        }, 10000)
        // eslint-disable-next-line
      } else if (currentFile?.value && holdId != currentFile?.id) {
        processImage(currentFile)
      }
    }
  }, [inProgressIndex, url, skuId])

  const processNextImage = (index, skuId, status) => {
    if (skuId && (status === 'processing' || status === 'accepted')) {
      getImage(skuId)
        .then(result => {
          if (
            result?.status === 'processed' ||
            result?.status === 'processing_failed'
          ) {
            carrom?.setHoldFile(prevHoldFile => {
              return prevHoldFile.map(file => {
                if (parseInt(file?.id) === parseInt(index)) {
                  return {
                    ...file,
                    input_url: result?.input_url,
                    output_url: result?.output_url,
                    uploadStatus: result?.status
                  }
                } else {
                  return file
                }
              })
            })
            clearInterval(timer)
            const nextIndex = parseInt(index) + 1
            if (!!fileDetails[nextIndex]) {
              processImage(fileDetails[nextIndex])
            }
            setInProgressIndex(nextIndex)
          }
        })
        .catch(error => {
          clearInterval(timer)
          const nextIndex = parseInt(index) + 1
          if (!!fileDetails[nextIndex]) {
            processImage(fileDetails[nextIndex])
          }
          setInProgressIndex(nextIndex)
        })
    }
    if (index >= fileDetails?.length || !!!status) {
      clearInterval(timer)
    }
  }
  const handleClick = () => {
    if (fileDetails?.length > 0) {
      carrom?.setShowTable(true)
      carrom?.setIsButtonDisabled(true)
      if (!!!fileDetails[0]?.value) {
        uploadFile(files)
      }
    } else {
      toast('bitte Dateien auswählen..')
    }
    if (
      fileDetails[
        lastUploadedFileIndex === null ? 0 : lastUploadedFileIndex + 1
      ]?.value !== null &&
      fileDetails[
        lastUploadedFileIndex === null ? 0 : lastUploadedFileIndex + 1
      ]?.value !== ''
    ) {
      processImage(fileDetails[0])
    }
  }
  const resetStates = e => {
    e.preventDefault()
    clearInterval(timer)
    carrom?.setShowTable(false)
    carrom?.setHoldFile([])
    carrom?.setPreviewImages([])
    carrom?.setIsButtonDisabled(false)
    carrom?.setInput([])
    setHoldId(null)
    setInProgressIndex(null)
    //setCurrentFileIndex(null);
    setLastUploadedFileIndex(null)
    setUrl(null)
    setSkuId(null)
    //setCurrentChunkIndex(null);
    setFormData(defaultValues)
  }

  return (
    <div className='mb-10 mt-14'>
      <h1 className='text-3xl text-center font-bold mx-3'>Parameter</h1>
      <div className='flex flex-wrap gap-y-4 mx-auto max-w-screen-lg w-full gap-4 mt-5'>
        <div className='flex flex-col gap-y-4 relative pb-4 w-full md:w-[33%]'>
          <label
            htmlFor='description'
            className='text-base text-left font-semibold leading-5 tracking-normal m-0 p-0 text-[rgb(var(--foreground-rgb))]'
          >
            Hintergrund-ID
          </label>
          <div className='flex'>
            {showDropdown?.bg_Id ? (
              <InputField
                name='BG_ID'
                type='text'
                placeholder='Hintergrund-ID eingeben'
                autoComplete='off'
                value={formData?.bg_id}
                handleChange={e => handleInputChange(e, 'bg_id')}
              />
            ) : (
              <Select
                key={`category-select-for-venue`}
                className={'block w-full  text-sm font-normal leading-normal '}
                options={backgroundOptions}
                isClearable={true}
                onChange={data => {
                  handleInputChange(data, 'bg_id', 'select')
                }}
                components={{ IndicatorSeparator: null }}
                placeholder={'Select'}
              />
            )}
            <div className='flex items-center ml-4'>
              <button
                className='cursor-pointer h-11 w-11 border border-black items-center rounded-md mx-auto text-center'
                onClick={() =>
                  setShowDropDown({
                    ...showDropdown,
                    bg_Id: !showDropdown.bg_Id
                  })
                }
              >
                {showDropdown?.bg_Id ? (
                  <FaList
                    style={{
                      height: '1em',
                      width: '1em',
                      cursor: 'pointer',
                      margin: 'auto'
                    }}
                  />
                ) : (
                  <MdEdit
                    style={{
                      height: '1em',
                      width: '1em',
                      cursor: 'pointer',
                      margin: 'auto'
                    }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
        <div className='flex flex-col gap-y-4 relative pb-4 w-full md:w-[33%]'>
          <label
            htmlFor='Number Plate'
            className='text-base text-left font-semibold leading-5 tracking-normal m-0 p-0 text-[rgb(var(--foreground-rgb))]'
          >
            Nummernschild
          </label>
          <div className='flex'>
            {showDropdown?.number_plate ? (
              <InputField
                name='Number_Plate'
                type='text'
                placeholder='Enter Number Plate'
                autoComplete='off'
                handleChange={e => handleInputChange(e, 'number_plate')}
                value={formData?.number_plate}
              />
            ) : (
              <Select
                key={`category-select-for-venue`}
                className={'block w-full  text-sm font-normal leading-normal '}
                options={NumberPlateOptions}
                // value={"value"}
                isClearable={true}
                onChange={data => {
                  handleInputChange(data, 'number_plate', 'select')
                }}
                components={{ IndicatorSeparator: null }}
                placeholder={'Select'}
              />
            )}
            <div className='flex items-center ml-4'>
              <button
                className='cursor-pointer h-11 w-11 border border-black items-center rounded-md mx-auto text-center'
                onClick={() =>
                  setShowDropDown({
                    ...showDropdown,
                    number_plate: !showDropdown.number_plate
                  })
                }
              >
                {showDropdown.number_plate ? (
                  <FaList
                    style={{
                      height: '1em',
                      width: '1em',
                      cursor: 'pointer',
                      margin: 'auto'
                    }}
                  />
                ) : (
                  <MdEdit
                    style={{
                      height: '1em',
                      width: '1em',
                      cursor: 'pointer',
                      margin: 'auto'
                    }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
        <div className='flex flex-col gap-y-4 relative pb-4 w-full md:w-[30%]'>
          <label
            htmlFor='description'
            className='text-base text-left font-semibold leading-5 tracking-normal m-0 p-0 text-[rgb(var(--foreground-rgb))]'
          >
            Innenbereich
          </label>
          <InputField
            name='Interior'
            type='number'
            placeholder='Innenraum betreten'
            autoComplete='off'
            handleChange={e => handleInputChange(e, 'interior_regeneration')}
            value={formData?.interior_regeneration}
          />
        </div>
      </div>

      <div className='flex flex-wrap gap-y-4 mx-auto max-w-screen-lg w-full gap-4 mt-5'>
        <fieldset
          key={`window`}
          className='w-full border border-solid border-gray-300 p-3'
        >
          <legend className='text-sm' key={`window-legend`}>
            Fenster
          </legend>
          <div className='mx-auto'>
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4'>
              <div className='flex flex-col flex-wrap gap-y-4 relative pb-4 w-full lg:w-full md:w-full sm:w-full'>
                <div className='bg-list  mx-auto'>
                  <div className=''>
                    <h3 className='title-18'>Intensität der Tönung</h3>
                    <div className='select-range-slider mt-[11px]'>
                      <div className='flex gap-3'>
                        <input
                          type='range'
                          className='w-full'
                          min='0'
                          max='1'
                          step='0.01'
                          value={
                            formData?.window_refinement?.TRANSPARENCY || 0.45
                          }
                          onChange={e => handleInputChange(e, 'TRANSPARENCY')}
                        />
                        <span className='font-semibold text-[#c40013]'>
                          {formData?.window_refinement?.TRANSPARENCY}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex flex-col flex-wrap gap-y-4 relative pb-3 w-full   sm:w-full'>
                <label
                  htmlFor={`TINT_COLOR`}
                  className='text-base  font-semibold leading-5 tracking-normal m-0 p-0 text-[rgb(var(--foreground-rgb))] text-center'
                >
                  Farbton Farbe
                </label>
                <input
                  type='color'
                  onChange={e => handleInputChange(e, 'TINT_COLOR')}
                  className=' text-centerp-1 h-8 w-8 block bg-white border border-gray-200 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 mx-auto'
                  id='hs-color-input'
                  title='Choose your color'
                ></input>
              </div>
              <div className='flex flex-col flex-wrap gap-y-4 relative pb-4 w-full   sm:w-full'>
                <label
                  htmlFor={`TONE_ON_TONE`}
                  className='text-base font-semibold leading-5 tracking-normal m-0 p-0 text-[rgb(var(--foreground-rgb))] text-center'
                >
                  Ton in Ton
                </label>
                <input
                  type='checkbox'
                  className='text-center'
                  name={`TONE_ON_TONE`}
                  autoComplete='off'
                  onChange={e => handleInputChange(e, 'TONE_ON_TONE')}
                  checked={formData?.window_refinement?.TONE_ON_TONE}
                  required={true}
                />
              </div>
              <div className='flex flex-col flex-wrap gap-y-4 relative pb-4 w-full  sm:w-full'>
                <label
                  htmlFor={`ADD_GLARE`}
                  className='text-base  font-semibold leading-5 tracking-normal m-0 p-0 text-[rgb(var(--foreground-rgb))] text-center'
                >
                  Blendung hinzufügen
                </label>
                <input
                  className='text-center'
                  type='checkbox'
                  min={0}
                  name={`ADD_GLARE`}
                  autoComplete='off'
                  onChange={e => handleInputChange(e, 'ADD_GLARE')}
                  checked={formData?.window_refinement?.ADD_GLARE}
                  required={true}
                />
              </div>
            </div>
          </div>
        </fieldset>
        <small>
          Hinweis: Um optimale Ergebnisse zu erzielen, belassen Sie bitte alle
          Felder auf den Standardwerten. Vielen Dank!
        </small>
        <div className='flex flex-wrap gap-y-4 mr-0 max-w-screen-lg w-full gap-4 mt-5 justify-end'>
          <div className='upload-modal-footer'>
            <button onClick={resetStates} className='btn-reset leading-5'>
              Zurücksetzen
            </button>
            <button
              onClick={handleClick}
              disabled={carrom?.isButtonDisabled}
              className='btn-primary leading-5'
            >
              {carrom?.isButtonDisabled ? <LoadingSpinner /> : 'einreichen'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Form
